import { Box, Container, Img, Text } from '@chakra-ui/react'
import * as ico from '.'

const Icons = () => {
  const arr: { key: string, value: string }[] = []
  Object.entries(ico).forEach(([key, value]) => {
    if (key.toLocaleLowerCase().endsWith('string')) {
      const i = key.lastIndexOf('String')
      arr.push({ key: key.substring(0, i), value: value as string })
    }
  })

  return (
    <Container>

      <Box display='grid' gridTemplateColumns='repeat(auto-fill, minmax(70px, 100px))' gap={4}>
        {
          arr.map(item =>
            <Box key={item.key} w={20}>
              <Text fontWeight='bold' fontSize={10}>{item.key}</Text>
              <Img w={10} src={`data:image/svg+xml;utf8,${encodeURIComponent(item.value)}`} />
            </Box>
          )
        }
      </Box>
    </Container>
  )
}

export default Icons